import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import search from './modules/search'
import state from './modules/state'
import merchants from './modules/merchants'
import terminals from './modules/terminals'
import processing from './modules/processing'
import cards from './modules/cards'
import countries from './modules/countries'
import currency from './modules/currency'
import afdecision from './modules/afdecision'
import afrules from './modules/afrules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    auth,
    search,
    state,
    merchants,
    terminals,
    processing,
    cards,
    currency,
    countries,
    afdecision,
    afrules
  },
  state: {
    SidebarOpen: false,
    Collapse: true
  },
  getters: {
    isSidebarOpened: state => state.SidebarOpen,
    isCollapsed: state => state.Collapse
  },
  actions: {
    toggleSidebar({
      commit
    }) {
      return new Promise((resolve, reject) => {
        commit('toggleSidebar')
        resolve()
      })
    },

    showSidebar({
      state,
      commit
    }) {
      if (state.Collapse) {
        return new Promise((resolve, reject) => {
          commit('showSidebar')
          resolve()
        })
      }
    },
    hideSidebar({
      state,
      commit
    }) {
      if (state.Collapse) {
        return new Promise((resolve, reject) => {
          commit('hideSidebar')
          resolve()
        })
      }
    }
  },
  mutations: {
    toggleSidebar(state) {
      state.Collapse = !state.Collapse
    },
    showSidebar(state) {
      state.SidebarOpen = true
    },
    hideSidebar(state) {
      state.SidebarOpen = false
    }
  }
})